<template>
  <b-modal id="deviceFormModal" size="xl" hide-footer>
    <b-row slot="modal-header">
      <b-col>
        <h6>{{$t('views.excmdevice.create.title')}}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Create :openedInModal="true"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../../../excmdevice/Create'
export default {
  name: 'DeviceFormModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmdevice.form.show
    },
    close () {
      return this.$store.state.modals.excmdevice.form.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      if (this.close === 1) {
        this.$store.state.modals.excmdevice.form.close = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1) {
        this.$store.state.modals.excmdevice.form.show = 0
        this.$bvModal.show('deviceFormModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('deviceFormModal')
    }
  }
}
</script>
